'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from 'react';
import { CanAddProduct, CanAddVariant, filteredInventoryByCurrentBasket, getVariantTotalInventory, Inventory, isModifierVariantAvailable, canAddProductWithModifiers, canAddProductVariantWithModifiers, ProductVariantWithModifiers } from './inventory.utils';
import { OrderLine } from '@ordering/types/Order';
import { ProductVariantWithoutModifiers } from '@ordering/gql/graphql';
type Values = {
  inventory: Inventory;
  canAddProduct: (props: CanAddProduct) => boolean;
  canAddVariant: (props: CanAddVariant) => boolean;
  canAddVariantWithModifiers: (variant: ProductVariantWithModifiers, basket: OrderLine[], quantityToAdd?: number, existingOrderLineId?: string | null) => boolean;
  isModifierVariantAvailable: (modifierVariant: ProductVariantWithoutModifiers, basket?: OrderLine[]) => boolean;
};
const InventoryContext = createContext<Values>({} as any);
export const InventoryProvider = t0 => {
  const $ = _c(17);
  const {
    children,
    inventory
  } = t0;
  let t1;
  if ($[0] !== inventory) {
    t1 = t2 => {
      const {
        variant,
        existingOrderLineId: t3,
        basket,
        quantityToAdd
      } = t2;
      const existingOrderLineId = t3 === undefined ? null : t3;
      if (!inventory) {
        return true;
      }
      const inventoryOnHand = filteredInventoryByCurrentBasket(basket, existingOrderLineId, inventory);
      const inventoryNeeded = getVariantTotalInventory(variant, quantityToAdd);
      for (const [componentId, quantityNeeded] of Object.entries(inventoryNeeded)) {
        const availableQuantity = inventoryOnHand[componentId];
        if (availableQuantity !== undefined && availableQuantity < quantityNeeded) {
          return false;
        }
      }
      return true;
    };
    $[0] = inventory;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canAddVariant = t1;
  let t2;
  if ($[2] !== inventory) {
    t2 = t3 => {
      const {
        variants,
        basket: t4
      } = t3;
      const basket_0 = t4 === undefined ? [] : t4;
      if (!inventory || variants.length === 0) {
        return true;
      }
      return canAddProductWithModifiers(variants, inventory, basket_0);
    };
    $[2] = inventory;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const canAddProduct = t2;
  let t3;
  if ($[4] !== inventory) {
    t3 = (modifierVariant, t4) => {
      const basket_1 = t4 === undefined ? [] : t4;
      return isModifierVariantAvailable(modifierVariant, inventory, basket_1);
    };
    $[4] = inventory;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const checkModifierVariantAvailability = t3;
  let t4;
  if ($[6] !== inventory) {
    t4 = (variant_0, basket_2, t5, t6) => {
      const quantityToAdd_0 = t5 === undefined ? 1 : t5;
      const existingOrderLineId_0 = t6 === undefined ? null : t6;
      return canAddProductVariantWithModifiers(variant_0, inventory, basket_2, quantityToAdd_0, existingOrderLineId_0);
    };
    $[6] = inventory;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const checkVariantWithModifiers = t4;
  let t5;
  if ($[8] !== canAddProduct || $[9] !== canAddVariant || $[10] !== checkModifierVariantAvailability || $[11] !== checkVariantWithModifiers || $[12] !== inventory) {
    t5 = {
      inventory,
      canAddProduct,
      canAddVariant,
      canAddVariantWithModifiers: checkVariantWithModifiers,
      isModifierVariantAvailable: checkModifierVariantAvailability
    };
    $[8] = canAddProduct;
    $[9] = canAddVariant;
    $[10] = checkModifierVariantAvailability;
    $[11] = checkVariantWithModifiers;
    $[12] = inventory;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const values = t5;
  let t6;
  if ($[14] !== children || $[15] !== values) {
    t6 = <InventoryContext.Provider value={values}>{children}</InventoryContext.Provider>;
    $[14] = children;
    $[15] = values;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const useInventory = () => {
  const context = useContext(InventoryContext);
  if (!context) {
    throw new Error("useInventory must be used within an InventoryProvider");
  }
  return context;
};